module.exports = __webpack_public_path__ + "img/icon-restaurant-close-restaurant.9a5a0ce8.png";